(function () {
    'use strict';

    angular
        .module('app.login')
        .component('sc3Login', {
            templateUrl: 'app/login/login.component.html',
            controller: LoginComponent
        });

    var noop = angular.noop;

    LoginComponent.$inject = ['signInManager', '$window', '$state', '$stateParams', 'user', 'clubAdminStateName', 'associationAdminStateName', 'homeStateName', 'renewalRequiredModal', 'Member', 'login_resources', 'renewRedirect', 'clubMembershipLevelType', 'accountDetailsModal', 'alert', 'emailConfirmationModal', 'manageSettingsModal', 'geniusRedirect'];
    function LoginComponent(signInManager, $window, $state, $stateParams, user, clubAdminStateName, associationAdminStateName, homeStateName, renewalRequiredModal, Member, resources, renewRedirect, clubMembershipLevelType, accountDetailsModal, alert, emailConfirmationModal, manageSettingsModal, geniusRedirect) {
        // Variables
        var ctrl = this;

        // Properties
        ctrl.username = null;
        ctrl.password = null;
        ctrl.errorMessage = null;

        ctrl.geniusRedirect = null;

        // Methods
        ctrl.$onInit = init;
        ctrl.submit = submit;

        //////////////////////////////////////

        function init() {
            if ($state.params.logout)
                signInManager.signOut(true);

            if ($stateParams.redirectURL) {

                ctrl.geniusRedirect = $stateParams.redirectURL;
                
            }
        }

        function submit() {
            var form = ctrl.form,
                summary = form.summary;

            ctrl.errorMessage = null;
            if (form.$valid)
                signInManager.signIn(ctrl.username, ctrl.password).then(success, error);

            function success() {
                var params = $state.params,
                    currentYear = new Date().getFullYear(),
                    isPendingBronzeMember = user.isPending && user.membershipLevel === clubMembershipLevelType.Bronze,
                    isPendingGoldMember = user.isPending && user.membershipLevel === clubMembershipLevelType.Gold,
                    needsEmailConfirmation = !user.termsAndConditionsDate || user.termsAndConditionsDate.getFullYear() < currentYear,
                    defaultRedirect = user.isAssociationAdmin ? associationAdminStateName : user.isAdmin ? clubAdminStateName : homeStateName,
                    redirectTo = params.redirectTo || defaultRedirect,
                    redirectParams = params.redirectParams,
                    go = $state.go.bind($state, redirectTo, redirectParams, null);

                if (ctrl.geniusRedirect)
                    geniusRedirect(false, ctrl.geniusRedirect);
                else
                    if (isPendingGoldMember)
                        showAccountDetailsModal(go);
                    else if (isPendingBronzeMember)
                        showRenewalRequiredModal(go);
                    else if (needsEmailConfirmation)
                        showEmailAddressConfirmationModal(go);
                    else
                        go();
            }
            function error(response) {
                var data = response.data,
                    redirectUri = data && data.error_uri, // <=== used to be redirect_uri, but it is no longer defined in class i am using.
                    description = data && (data.error_description || data.message) || resources.unknownLoginError,
                    renewalToken = data && data.renewalToken;

                ctrl.errorMessage = description;
                if (redirectUri)
                    renewRedirect(true, redirectUri);
                    //$window.location.href = redirectUri;
            }

            function showRenewalRequiredModal(callback) {
                renewalRequiredModal().result.then(renewAsGold, continueAsBronze);

                function renewAsGold() {
                    renewRedirect().catch(noop);
                }

                function continueAsBronze() {
                    Member.resetPendingStatus({ id: user.id }, callback, error, true);

                    function error(rejection) {
                        alert.error(resources.resetPendingStatusFailed);
                    }
                }
            }
            function showAccountDetailsModal(callback) {
                Member.getSettings({ id: user.id }, success, error);

                function success(settings) {
                    accountDetailsModal(settings).result.then(saveDetails, callback);
                }

                function error() {
                    alert.error(resources.accountDetailRequestFailed);
                }

                function saveDetails(details) {
                    details.isAgreeingToTermsAndConditions = true;
                    Member.saveSettings({ id: details.individualId }, details, callback, error, true);

                    function error() {
                        alert.error(resources.saveAccountDetailsFailed);
                    }
                }
            }
            function showEmailAddressConfirmationModal(callback) {
                emailConfirmationModal(user).result.then(callback);

                //function success() {
                //    manageSettingsModal().result.finally(callback);
                //}
            }
        }
    }
})();